/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Orders API Service
 */

import { createApi } from "@reduxjs/toolkit/query/react";
import type { Order } from "@/types";
import {
  baseQueryWithReauth,
  CACHE_TIMES,
  TAG_TYPES,
} from "@/redux/api-config";

export const ordersApi = createApi({
  reducerPath: "ordersApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [TAG_TYPES.ORDERS],
  // Keep data fresh for 5 minutes
  keepUnusedDataFor: CACHE_TIMES.MEDIUM,
  endpoints: (builder) => ({
    getOrderById: builder.query<Order, string>({
      query: (id) => `orders/${id}`,
      providesTags: (_result, _error, id) => [
        { type: TAG_TYPES.ORDERS, id },
        { type: TAG_TYPES.ORDERS, id: "LIST" },
      ],
      // Individual orders can be cached longer
      keepUnusedDataFor: CACHE_TIMES.LONG,
    }),
    getOrders: builder.query<Order[], void>({
      query: () => "orders",
      providesTags: (result) =>
        result
          ? [
              ...result.map((order) => ({
                type: TAG_TYPES.ORDERS,
                id: order.id,
              })),
              { type: TAG_TYPES.ORDERS, id: "LIST" },
            ]
          : [{ type: TAG_TYPES.ORDERS, id: "LIST" }],
    }),
  }),
});

export const { useGetOrderByIdQuery, useGetOrdersQuery } = ordersApi;
